import { useSearchPageProductOrParsedSearchString } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/useSearchPageProductOrParsedSearchString";
import { useSearchPageSpellCorrectedQuery } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageSpellCorrectedQuery";

export const useSearchPageSearchStringFullyTranslated = () => {
  const productOrParsedSearchString =
    useSearchPageProductOrParsedSearchString();
  const spellCorrectedQuery = useSearchPageSpellCorrectedQuery();

  return spellCorrectedQuery === undefined
    ? productOrParsedSearchString
    : spellCorrectedQuery;
};
